import React, { Fragment } from 'react';
import TitleBox from '../../components/common/TitleBox';
import MinigameCenter from '../../components/Minigame/MinigameCenter';
import SportsRight from '../../components/sports/SportsRight';

const EOSPowerball = () => {
    return (
        <Fragment>
            <TitleBox title="EOS파워볼" />
            <div className="contents_wrap">
                <div className="contents_box">
                    <MinigameCenter type="eos_powerball"/>
                    <SportsRight type="minigame"/>
                </div>
            </div>
        </Fragment>
    );
};

export default EOSPowerball;


// WEBPACK FOOTER //
// ./src/containers/minigame/EOSPowerball.js